import type { RouteObject } from "react-router-dom";
import MainLayout from "@/components/feature/MainLayout";
import Home from "@/pages/home/page";
import Movies from "@/pages/movies/page";
import TvShows from "@/pages/tvshows/page";
import News from "@/pages/news/page";
import Detail from "@/pages/detail/page";
import Search from "@/pages/search/page";
import Favorites from "@/pages/favorites/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "movies",
        element: <Movies />,
      },
      {
        path: "tvshows",
        element: <TvShows />,
      },
      {
        path: "news",
        element: <News />,
      },
      {
        path: "detail/:id",
        element: <Detail />,
      },
      {
        path: "search",
        element: <Search />,
      },
      {
        path: "favorites",
        element: <Favorites />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;